
define('text!presentation/common/tagEditor/views/tagEditor.html',[],function () { return '<input type="text" data-bind="tagEditorThemed: {allowTagValidator: allowTagValidator, removeTagValidator: removeTagValidator, tagItemTextProperty: tagItemTextProperty, tagItemValueProperty: tagItemValueProperty}, value: value" />\n';});

